








import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({})
export default class Section extends Vue {
  @Prop({ type: String }) title: any
  @Prop({ type: String }) subTitle: any
}
